import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import AnimatedCounter from '../AnimatedCounter/AnimatedCounter';
import { adoptionData } from '../../data/metrics';
import styles from './AdoptionSection.module.css';

const AdoptionSection = () => {
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: true
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 }
    }
  };

  return (
    <section id="adoption-section" className={styles.adoption} aria-labelledby="adoption-title">
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 id="adoption-title" className={styles.title}>
            Widespread Student Adoption
          </h2>
          <p className={styles.description}>
            The Ohio State App has become an essential tool for students across all academic levels,
            with exceptional adoption rates demonstrating its value to the Buckeye community.
          </p>
          <p className={styles.caption}>
            Data From Fall 2025
          </p>
        </div>

        <motion.div
          ref={ref}
          className={styles.stats}
          variants={containerVariants}
          initial="hidden"
          animate={inView ? 'visible' : 'hidden'}
        >
          <motion.div className={styles.statCard} variants={itemVariants}>
            <div className={styles.statType}>Undergraduate</div>
            <div className={styles.statPercentage}>
              <AnimatedCounter end={adoptionData.undergraduate.percentage} suffix="%" />
            </div>
            <div className={styles.statDetails}>
              <span className={styles.statNumber}>
                <AnimatedCounter end={adoptionData.undergraduate.appUsers} />
              </span>
              {' '}of {adoptionData.undergraduate.totalEnrollment.toLocaleString()} students
            </div>
          </motion.div>

          <motion.div className={styles.statCard} variants={itemVariants}>
            <div className={styles.statType}>Graduate</div>
            <div className={styles.statPercentage}>
              <AnimatedCounter end={adoptionData.graduate.percentage} suffix="%" />
            </div>
            <div className={styles.statDetails}>
              <span className={styles.statNumber}>
                <AnimatedCounter end={adoptionData.graduate.appUsers} />
              </span>
              {' '}of {adoptionData.graduate.totalEnrollment.toLocaleString()} students
            </div>
          </motion.div>

          <motion.div className={styles.statCard} variants={itemVariants}>
            <div className={styles.statType}>Professional</div>
            <div className={styles.statPercentage}>
              <AnimatedCounter end={adoptionData.professional.percentage} suffix="%" />
            </div>
            <div className={styles.statDetails}>
              <span className={styles.statNumber}>
                <AnimatedCounter end={adoptionData.professional.appUsers} />
              </span>
              {' '}of {adoptionData.professional.totalEnrollment.toLocaleString()} students
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default AdoptionSection;
